import { Box, styled } from '@mui/material'
import { Add } from '@mui/icons-material'
import CommentAuthorAvatar from './CommentAuthorAvatar'
import { CommentUser, CommentUserInfo } from 'features/collaboration/types'
import { theme } from '@carto/meridian-ds/theme'

export const COMMENT_MARKER_SIZE = theme.spacingValue * 4

const CommentRoot = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isAdding' && prop !== 'selected' && prop !== 'isUnread'
})<{ isAdding?: boolean; selected?: boolean; isUnread?: boolean }>(({ theme, isAdding, selected, isUnread }) => ({
  width: COMMENT_MARKER_SIZE,
  height: COMMENT_MARKER_SIZE,

  borderStyle: 'solid',
  borderWidth: selected || isAdding ? '2px' : '1px',
  borderColor: selected ? theme.palette.primary.main : theme.palette.default.outlinedBorder,
  backgroundColor: isUnread ? theme.palette.primary.light : theme.palette.background.paper,
  borderRadius: '50%',
  borderBottomLeftRadius: '2px',

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  color: theme.palette.text.secondary,
  cursor: isAdding ? 'default' : 'pointer',

  ...(!isAdding && {
    '&:hover': {
      borderColor: selected ? theme.palette.primary.dark : theme.palette.text.primary
    }
  })
}))

export type CommentMarkerProps = {
  user?: CommentUser
  author?: CommentUserInfo
  isAdding?: boolean
  isUnread?: boolean
  selected?: boolean
  resolved?: boolean
}

const CommentMarker = ({ user, author, isAdding, isUnread, selected, resolved }: CommentMarkerProps) => {
  return (
    <CommentRoot isAdding={isAdding} isUnread={isUnread} selected={selected}>
      {isAdding && <Add fontSize="medium" />}
      {!isAdding && author && <CommentAuthorAvatar user={user} author={author} disabled={resolved || user?.noAccess} />}
    </CommentRoot>
  )
}

export default CommentMarker
